import App from '../App'

import common from '@/router/common';
import order from '@/router/order';
export default [{
	path: '/',
	component: App, //顶层路由，对应index.html
	children: [
		...order,
		...common,
		{
			path: '*',
			redirect:to => {
				console.log(to)
				let path = '/home'
				let query = to.query
				switch (to.path) {
					case '/CommunityDetail':
						path = '/community/article'
						break;
					case '/CommunityVideo':
						path = '/community/article'
						break;
					case '/Shop':
						path = '/order/product'
						break;
					case '/ProductDetail':
					 	path = '/order/product/detail'
					 	break;
					case '/WebPage':
						path = window.Trace || path
						window.open(query.url)
						query = {}
					default:
						// statements_def
						break;
				}
				return {
					path,
					query,
				}
		    },
			meta: {
				code:'',
				requireAuth: false
			}
		}
	]
}]
